// - Import actions
var isValidEmail = function (email) {
    var re = /^(([^<>()\[\]\\.,:\s@"]+(\.[^<>()\[\]\\.,:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
var createServerRequestId = function (requestType, uniqueId) {
    return requestType + ":" + uniqueId;
};
function queryString(name, url) {
    if (url === void 0) { url = window.location.href; }
    name = name.replace(/[[]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i');
    var results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export default {
    isValidEmail: isValidEmail,
    queryString: queryString,
    createServerRequestId: createServerRequestId
};



//////////////////
// WEBPACK FOOTER
// ./src/api/StringAPI.ts
// module id = 72
// module chunks = 50